import { get, isString } from 'lodash-es';

export interface CsvColumn<D> {
  id: string;
  label: string;
  valueAccessor: string | ((value: D) => string);
}

class DataToCsvString<Data> {
  constructor(private data: Data[], private columns: CsvColumn<Data>[]) {}

  getCsvDataRows() {
    return this.data
      .map((line) =>
        this.columns
          .map(({ valueAccessor }) => {
            if (isString(valueAccessor)) {
              return get(line, valueAccessor, '');
            }
            return valueAccessor(line);
          })
          .join(','),
      )
      .join('\n');
  }

  getCsvHeaderRow() {
    return this.columns.map(({ label }) => label).join(',');
  }
}

export interface IDataExporter<Data> {
  getCsvDataString(data: Data[]): string;
}

export class DataExporter<Data> implements IDataExporter<Data> {
  constructor(private columns: CsvColumn<Data>[]) {}

  getCsvDataString(data: Data[]): string {
    const dataToCsv = new DataToCsvString(data, this.columns);
    return `data:text/csv;charset=utf-8,${dataToCsv.getCsvHeaderRow()}\n${dataToCsv.getCsvDataRows()}`.trim();
  }
}
